module.exports = __webpack_public_path__ + "img/dairy.d3d71674.jpg";